export default __webpack_public_path__ + "static/media/pizza1.f1bfde8b.png";